import EditJobTemplate from './EditJobTemplate';

export default EditJobTemplate;
